"use client";

import { Button } from "./Button";
import { LoadingPage } from "@/src/components/LoadingPage";
import { Show, SignInButton } from "@clerk/nextjs";
import { ReactNode, Suspense } from "react";

interface LayoutProps {
	children: ReactNode;
}

export function ContentLayout({ children }: LayoutProps) {
	return (
		<Suspense fallback={<LoadingPage />}>
			<Show when="signed-out">
				<h1 className="text-2xl font-medium my-1" role="heading">
					Sign in to continue...
				</h1>
				<SignInButton>
					<Button>🔑 Sign in</Button>
				</SignInButton>
			</Show>
			<Show when="signed-in">{children}</Show>
		</Suspense>
	);
}
